import React, { useEffect, useRef } from 'react'
import PovertyCycle from './PovertyCycle'
import whyImg from "../images/w3.png"
import { FaUsers, FaLayerGroup, FaFemale } from "react-icons/fa";


const WhyItMatters = () => {

     const servicesRef = useRef(null);
      
   useEffect (() => {
    const revealElements = servicesRef.current.querySelectorAll("[data-reveal]");
     const scrollReveal = () => {
        for (let i = 0; i < revealElements.length; i++) {
         const elementIsInScreen =
        revealElements[i].getBoundingClientRect().top < window.innerHeight / 1.15;
      
      if (elementIsInScreen) {
       revealElements[i].classList.add("revealed");
       } else {
          revealElements[i].classList.remove("revealed");
           }
        }
       };
      
       window.addEventListener("scroll", scrollReveal);
          scrollReveal(); // Initial check
      
          return () => {
            window.removeEventListener("scroll", scrollReveal);
          };
        }, []);

  return (
     <section className="why-matters section" ref={servicesRef}>
    <div className="container-fluid px-5">
      {/* Section Title */}
      <div className="section-title text-center" data-aos="fade-up">
        <h3 data-reveal>Why It Matters</h3>
      </div>
        <div
        className="why-matters-evidence"
        data-aos="fade-up"
        data-aos-delay="100"
        >
        <div className="why-matters-layout">
         
            <div className="why-matters-text" data-reveal>
            <p>
           Kenya faces a structural breakdown in the education-to-employment pipeline, and the
          burden is not gender-neutral. Each year, more than 700,000 young people
          approximately 73% of KCSE candidates do not transition directly into university.
            </p>

            <p>
             This leaves a large number of young people in grade bands where structured,
              affordable, and accredited post-secondary pathways are limited. Within this group, girls
              and young women are especially vulnerable, with approximately 420,000 girls falling
              into the lowest grade bands each year, narrowing their chances of entering university,
              TVET, digital skills training, or income-generating pathways.
            </p>

            <p>
             For girls from low-income households, the disadvantage is often deeper: poverty-related
              missed school days, unpaid care responsibilities, limited access to study support,
              menstrual health challenges, safety concerns, and lower household investment in girls’
              education can all affect performance and progression.
            </p>

         
            </div>

              <div className="why-matters-image" data-reveal>
            <img
                src={whyImg}
                alt="Students and education impact"
            />
            </div>
        </div>
  <div>
       <strong>
               Tuwe Initiative is responding to this gendered transition gap by supporting
              underserved young women with last-mile access to digital tools, AI skills,
              mentorship, confidence-building, and practical pathways into learning, work, and

              enterprise right where they are.
            </strong>
  </div>
        {/* Rest stays the same */}
        <p className="why-matters-subhead" data-reveal>
            <strong>What this means is that:</strong>
        </p>

<ul className="why-matters-list" data-reveal>
  <li>
    <FaUsers className="point-icon" />
    <span>
      <strong>Scale:</strong> Between 70 -73% of KCSE candidates do not qualify for University
admission.
    </span>
  </li>

  <li>
    <FaLayerGroup className="point-icon" />
    <span>
      <strong>Clustering:</strong> Nearly two thirds of candidates are concentrated in D+ to D-.
    </span>
  </li>

  <li>
    <FaFemale className="point-icon" />
    <span>
      <strong>Gender Gap:</strong> Girls make up 3 to 8% more of candidates in the D grades.
    </span>
  </li>
</ul>

        <p className="why-matters-source" data-reveal>
            <em>
            Source: Kenya National Bureau of Statistics (KNBS). Economic Survey (2021 to 2025 editions), Table 15.9: Number of Examination Centres, Candidates by Sex and KCSE Mean Grade, 2020 to 2024, based on data from the Kenya National Examinations Council (KNEC).
            </em>
        </p>
        </div>



      <PovertyCycle/>
      {/* Paragraph */}
      <div
        className="row justify-content-center"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        <div className="col-lg-10 text-center">
          <p data-reveal>
       
            But with your support, that story can change.
          </p>
        </div>
      </div>

      {/* Grid Cards */}
      <div
        className="progress-grid"
        data-aos="fade-up"
        data-aos-delay="250"
      >
        <div className="progress-card" data-reveal>
          <i className="bi bi-mortarboard-fill icon-point"></i>
          <p>A student completes high school with dignity.</p>
        </div>
        <div className="progress-card" data-reveal>
          <i className="bi bi-briefcase-fill icon-point"></i>
          <p>
            A young woman launches her digital business and uplifts her family.
          </p>
        </div>
        <div className="progress-card" data-reveal>
          <i className="bi bi-globe icon-point"></i>
          <p>
            A graduate discovers  pathways that lead to real
            livelihoods.
          </p>
        </div>
      </div>
    </div>
  </section>
  )
}

export default WhyItMatters